import { getLogger } from '../../libs/logger';
import { TimerObserver } from '../../libs/timerObserver';
import { timerKeys } from '../../shared/constants';

export enum PatientCallHoldSteps {
  CallHoldLaunched = 'callHoldLaunched',
  CallHoldResumed = 'callHoldResumed',
}

const logger = getLogger('patientCallHoldTimer');

export const patientCallHoldTimer = new TimerObserver<PatientCallHoldSteps>(
  timerKeys.callHold,
  logger,
);
